import React from 'react';
import PropTypes from 'prop-types';
import {
  getRootClassNames,
  SWAN_STYLE_KEY_MAP,
  SwanHead,
  SwanProvider,
  useBrowserClasses,
} from '@vp/swan';
import { BOOKENDS_SWAN_STYLES } from '@vp/esi-bookends';
import { Helmet } from 'react-helmet';
import {
  MY_ACCOUNT_PAGE_SECTION,
  MY_ACCOUNT_PAGE_STAGE,
  ORDER_HISTORY_PAGE_NAME,
} from '../../constants/orderdetailsui';

export const SwanEnabler = props => {
  const { children } = props;

  /**
   * Hey! You! Thinking about removing a style key? Be careful, a third-party component may need it!
   * (i.e. Bookends, UX mods, etc.)
   *
   * TODO - to support SWAN V1 and V2, we added legacy styles and the modal css below
   */
  const ODUI_SWAN_STYLES = [
    SWAN_STYLE_KEY_MAP.accordion,
    SWAN_STYLE_KEY_MAP.alertBox,
    SWAN_STYLE_KEY_MAP.banner,
    SWAN_STYLE_KEY_MAP.button,
    SWAN_STYLE_KEY_MAP.carousel,
    SWAN_STYLE_KEY_MAP.core,
    SWAN_STYLE_KEY_MAP.grid,
    SWAN_STYLE_KEY_MAP.hidden,
    SWAN_STYLE_KEY_MAP.icon,
    SWAN_STYLE_KEY_MAP.listbox,
    SWAN_STYLE_KEY_MAP.modalDialog,
    SWAN_STYLE_KEY_MAP.pagination,
    SWAN_STYLE_KEY_MAP.popover,
    SWAN_STYLE_KEY_MAP.progressiveImage,
    SWAN_STYLE_KEY_MAP.selectionSet,
    SWAN_STYLE_KEY_MAP.spinner,
    SWAN_STYLE_KEY_MAP.standardTile,
    SWAN_STYLE_KEY_MAP.table,
    SWAN_STYLE_KEY_MAP.tabs,
    SWAN_STYLE_KEY_MAP.toggleSwitch,
    SWAN_STYLE_KEY_MAP.utility,
    SWAN_STYLE_KEY_MAP.visible,
  ];

  const eagerlyLoadedSwanStyles = [
    ...new Set([...ODUI_SWAN_STYLES, ...BOOKENDS_SWAN_STYLES]),
  ];

  const browserClassName = useBrowserClasses();
  const rootClassName = getRootClassNames();

  return (
    <SwanProvider>
      <Helmet
        bodyAttributes={{ class: rootClassName }}
        htmlAttributes={{ class: browserClassName }}
      >
        <meta name="pageName" content={ORDER_HISTORY_PAGE_NAME} />
        <meta name="pageSection" content={MY_ACCOUNT_PAGE_SECTION} />
        <meta name="pageStage" content={MY_ACCOUNT_PAGE_STAGE} />
        {/* Snowflake the modal dialog background */}
        <style type="text/css">
          {`.swan-modal-dialog-backdrop {
              background-color: var(--swan-modal-dialog-backdrop-color-standard);
              bottom: 0;
              left: 0;
              position: fixed;
              right: 0;
              top: 0;
              z-index: var(--swan-elements-modal-dialog-backdrop-z-index);
            }`}
        </style>
      </Helmet>
      <SwanHead
        renderWith={Helmet}
        renderStyleContentAsChildren
        styleSheetKeys={eagerlyLoadedSwanStyles}
      />
      <div>{children}</div>
    </SwanProvider>
  );
};

SwanEnabler.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};
